module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"dashboard":{"totals_partial":{"title":"Mês atual","total_shipments":"Total de remessas","total_clients":"Total de clientes","total_tickets":"Total de tickets"}}},"en":{"dashboard":{"totals_partial":{"title":"Current Month","total_shipments":"Total shipments","total_clients":"Total clients","total_tickets":"Total tickets"}}}}')
  delete Component.options._Ctor
}
